/*eslint-disable*/
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import API from '../../api/apiInstance';

export const getDepartments = (): any => API.get('/departments/list');
